export default {
    nodes: state => state.nodes,
    inputs: state => state.inputs
}